var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12 border border-secondary rounded",staticStyle:{"background-color":"white"}},[(_vm.data)?_c('Map',{attrs:{"area":_vm.area,"data":_vm.data}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }